import Storage from './Storage'

export default class Errors extends Storage
{
    first(field) {
        let error = this.get(field)

        if( Array.isArray(error) && error.length )
            return error.slice(0).shift() // copy array and get first element

        return null
    }

    get(field) {
        let error = super.get(field)

        if( Array.isArray(error) && error.length )
            return error

        return []
    }

    all(firstErrorOnly = false) {
        let all = super.all()

        if( ! firstErrorOnly )
            return all

        let result = {}
        this.keys().forEach( field => {
            let errors = all[field].slice(0) // Copy Array.
            result[field] = errors.shift()
        })
        return result
    }

    add(field, error) {
        if( Array.isArray(error) ) {
            error.forEach( errorText => {
                this.add(field, errorText)
            })
            return
        }

        let fieldErrors = super.get(field)

        if( ! Array.isArray(fieldErrors) )
            fieldErrors = []

        if( fieldErrors.indexOf(error) === -1 )
            fieldErrors.push(error)

        super.set(field, fieldErrors)
    }

    setMultiple(errors) {
        this.clear()

        for(let key in errors) {
            let error = errors[key]

            if( ! Array.isArray(error) )
                error = [error]

            this.add(key, error)
        }
    }

    has(key) {
        return Boolean(super.has(key) && this[key].length)
    }

    set(key, value) {
        console.warn('[Errors]: Do not use "set" method directly. Please use method "add" instead.')
        super.set(key, value)
    }
}
